import script from "./SelectStaff.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectStaff.vue?vue&type=script&setup=true&lang=js"

import "./SelectStaff.vue?vue&type=style&index=0&id=069d6892&scoped=true&lang=css"

import exportComponent from "/var/www/html/frezka-saas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069d6892"]])

export default __exports__